// Single source of truth for site content — Dr Indresh Dixit
// Doctor photos (provided, not stock)
export const PHOTO_HERO =
  "https://customer-assets.emergentagent.com/job_varanasi-gastro/artifacts/jkchhm21_images%20%282%29.jpeg";
export const PHOTO_ABOUT =
  "https://customer-assets.emergentagent.com/job_varanasi-gastro/artifacts/2tgt4ka9_images%20%283%29.jpeg";

export const PHONE_DISPLAY = "+91 93696 98080";
export const PHONE_TEL = "tel:+919369698080";
export const WHATSAPP_URL =
  "https://wa.me/919369698080?text=Hello%20Dr.%20Indresh%2C%20I%20would%20like%20to%20book%20an%20appointment.";

export const YOUTUBE_CHANNEL = "https://www.youtube.com/@DrIndreshDixit.Gastro";

export const SOCIAL = {
  youtube: "https://www.youtube.com/@DrIndreshDixit.Gastro",
  facebook: "https://www.facebook.com/drindreshdixit/",
  instagram: "https://www.instagram.com/drindreshdixit/",
};

export const TRUST = {
  reviews: "900+",
  rating: "4.8",
  locations: "2",
  experience: "10+",
};

export const LOCATIONS = [
  {
    id: "lanka",
    name: "Avashyakata Gastro Clinic — Lanka",
    address:
      "B 31/18-A-D-3, behind V2 Mall, Rashmi Nagar Colony, Saket Nagar Colony, Lanka, Varanasi",
    hours: "8:30 AM – 5:00 PM",
    days: "Mon – Sat",
    gbpUrl: "https://maps.app.goo.gl/bSxnikJgGsFyg3Gg6",
    mapEmbed:
      "https://www.google.com/maps?q=Avashyakata+Gastro+Clinic+Lanka+Varanasi&output=embed",
  },
  {
    id: "chetganj",
    name: "Avashyakata Gastro Clinic — Chetganj",
    address:
      "Bagh Bariyar Singh, C 6/85, near Saroja Petrol Pump, Piplani Katra, Chetganj, Varanasi",
    hours: "6:00 PM – 9:00 PM",
    days: "Mon – Sat",
    gbpUrl: "https://maps.app.goo.gl/MA34vXRyD8tUHGUn7",
    mapEmbed:
      "https://www.google.com/maps?q=Avashyakata+Gastro+Clinic+Chetganj+Varanasi&output=embed",
  },
];

export const SYMPTOMS = [
  {
    slug: "acidity-treatment-varanasi",
    title: "Acidity & Heartburn",
    blurb:
      "Burning chest, sour reflux, throat irritation — find lasting relief from chronic acidity.",
    tag: "Most searched",
  },
  {
    slug: "gas-problem-treatment-varanasi",
    title: "Gas & Bloating",
    blurb:
      "Persistent gas, abdominal distension and discomfort after meals diagnosed and treated.",
    tag: "Common",
  },
  {
    slug: "constipation-specialist-varanasi",
    title: "Chronic Constipation",
    blurb: "Long-standing constipation, hard stool and incomplete evacuation.",
    tag: "Lifestyle",
  },
  {
    slug: "blood-in-stool-treatment",
    title: "Blood in Stool",
    blurb:
      "Bright red or dark blood — a warning sign that requires immediate evaluation.",
    tag: "Urgent",
  },
  {
    slug: "abdominal-pain-specialist",
    title: "Abdominal Pain",
    blurb: "Upper, lower or recurrent pain — diagnosis with precision endoscopy.",
    tag: "Diagnostic",
  },
  {
    slug: "jaundice-treatment",
    title: "Jaundice",
    blurb:
      "Yellow eyes, dark urine, fatigue — comprehensive liver workup and treatment.",
    tag: "Liver",
  },
  {
    slug: "bloating-treatment",
    title: "Bloating & Fullness",
    blurb: "Persistent bloating with or without weight change, fully assessed.",
    tag: "Functional",
  },
  {
    slug: "ibs-symptoms-treatment",
    title: "IBS — Irritable Bowel",
    blurb:
      "Alternating diarrhea and constipation with cramping. Long-term management programs.",
    tag: "Chronic",
  },
];

export const CONDITIONS = [
  {
    category: "Liver",
    items: [
      { label: "Fatty Liver Disease", slug: "fatty-liver-treatment" },
      { label: "Liver Cirrhosis", slug: "liver-cirrhosis-treatment" },
      { label: "Hepatitis B", slug: "hepatitis-b-treatment" },
      { label: "Hepatitis C", slug: "hepatitis-c-treatment" },
    ],
  },
  {
    category: "Stomach & Esophagus",
    items: [
      { label: "GERD / Acid Reflux", slug: "gerd-treatment" },
      { label: "Gastritis", slug: "gastritis-treatment" },
      { label: "Peptic Ulcer Disease", slug: "peptic-ulcer-treatment" },
      { label: "H. pylori", slug: "gastritis-treatment" },
      { label: "Hematemesis (Vomiting Blood)", slug: "hematemesis-treatment" },
    ],
  },
  {
    category: "Intestine (IBD & IBS)",
    items: [
      { label: "Ulcerative Colitis", slug: "ulcerative-colitis-treatment" },
      { label: "Crohn's Disease", slug: "crohns-disease-treatment" },
      { label: "Hemorrhoids (Piles)", slug: "hemorrhoids-piles-treatment" },
      { label: "IBS", slug: null, symptomSlug: "ibs-symptoms-treatment" },
      { label: "Chronic Diarrhoea", slug: null, symptomSlug: "ibs-symptoms-treatment" },
    ],
  },
  {
    category: "Pancreas & Biliary",
    items: [
      { label: "Acute Pancreatitis", slug: "pancreatitis-treatment" },
      { label: "Chronic Pancreatitis", slug: "pancreatitis-treatment" },
      { label: "Gallstones", slug: null, symptomSlug: "jaundice-treatment" },
      { label: "Bile Duct Stones", slug: null, symptomSlug: "jaundice-treatment" },
    ],
  },
];

export const PROCEDURES = [
  { slug: "upper-gi-endoscopy", title: "Upper GI Endoscopy", summary: "High-definition diagnostic and therapeutic endoscopy of the esophagus, stomach and duodenum.", duration: "15–20 min" },
  { slug: "colonoscopy", title: "Colonoscopy", summary: "Full colonic examination for blood in stool, screening and polyp removal.", duration: "30–45 min" },
  { slug: "ercp", title: "ERCP", summary: "Advanced endoscopic procedure for bile duct stones, strictures and pancreatic disease.", duration: "45–60 min" },
  { slug: "eus", title: "Endoscopic Ultrasound (EUS)", summary: "Combined endoscopy + ultrasound for staging and tissue diagnosis of GI cancers.", duration: "30–45 min" },
  { slug: "fibroscan", title: "FibroScan", summary: "Non-invasive liver stiffness measurement — quantify fatty liver and fibrosis.", duration: "10 min" },
  { slug: "polypectomy", title: "Polypectomy", summary: "Removal of pre-cancerous colon polyps during colonoscopy — prevents colorectal cancer.", duration: "During colonoscopy" },
  { slug: "foreign-body-removal", title: "Foreign Body Removal", summary: "Endoscopic removal of swallowed coins, batteries, fish-bones and food bolus.", duration: "15–30 min" },
];

export const VIDEOS = {
  featured: {
    id: "TnvJ28isrlU",
    title: "Gastro & Liver Care — Patient Education by Dr. Indresh Dixit",
    duration: "Watch now",
    thumb: "https://img.youtube.com/vi/TnvJ28isrlU/maxresdefault.jpg",
    href: "https://www.youtube.com/watch?v=TnvJ28isrlU",
  },
  list: [
    {
      id: "6cwUK9HQWC8",
      title: "Fatty Liver — diagnosis & reversal",
      duration: "Watch",
      thumb: "https://img.youtube.com/vi/6cwUK9HQWC8/hqdefault.jpg",
      href: "https://www.youtube.com/watch?v=6cwUK9HQWC8",
    },
    {
      id: "LJVZxiO8GfI",
      title: "Upper GI Endoscopy explained",
      duration: "Watch",
      thumb: "https://img.youtube.com/vi/LJVZxiO8GfI/hqdefault.jpg",
      href: "https://www.youtube.com/watch?v=LJVZxiO8GfI",
    },
    {
      id: "Gc6RgwWsb1k",
      title: "Gas, bloating and IBS — the basics",
      duration: "Watch",
      thumb: "https://img.youtube.com/vi/Gc6RgwWsb1k/hqdefault.jpg",
      href: "https://www.youtube.com/watch?v=Gc6RgwWsb1k",
    },
  ],
  all: [
    { id: "TnvJ28isrlU", title: "Gastro & Liver Care — Patient Education", duration: "Watch", category: "Patient Stories" },
    { id: "6cwUK9HQWC8", title: "Fatty Liver — diagnosis & reversal", duration: "Watch", category: "Liver Health" },
    { id: "LJVZxiO8GfI", title: "Upper GI Endoscopy explained", duration: "Watch", category: "Endoscopy" },
    { id: "Gc6RgwWsb1k", title: "Gas, bloating and IBS — the basics", duration: "Watch", category: "IBS & Bowel" },
    { id: "BbuJjuedBvY", title: "Hepatitis B — what every patient should know", duration: "Watch", category: "Hepatitis" },
    { id: "PxXmf3Y978w", title: "Patient feedback — a real recovery story", duration: "Watch", category: "Patient Stories" },
    { id: "b2YZZHt-zyA", title: "Ulcerative Colitis — diet & lifestyle tips", duration: "Watch", category: "IBS & Bowel" },
    { id: "v07QGeQycvU", title: "Chronic Constipation — long-term solutions", duration: "Watch", category: "IBS & Bowel" },
    { id: "JSCNg4ia_uw", title: "Jaundice — causes & treatment", duration: "Watch", category: "Liver Health" },
    { id: "YaDFPZq8L6o", title: "When is a colonoscopy really needed?", duration: "Watch", category: "Endoscopy" },
    { id: "75R96cQO_Iw", title: "Liver Cirrhosis — essentials patients ask about", duration: "Watch", category: "Liver Health" },
    { id: "NlXYIXEqpRs", title: "Pancreatitis — acute vs chronic", duration: "Watch", category: "Diet & Lifestyle" },
    { id: "94RqCz2T-Tc", title: "GERD — modern management approach", duration: "Watch", category: "Acidity & Reflux" },
    { id: "7fyzwlB5HTM", title: "Blood in stool — never ignore these signs", duration: "Watch", category: "IBS & Bowel" },
    { id: "jQmpa-HkG7k", title: "FibroScan — what your numbers really mean", duration: "Watch", category: "Liver Health" },
    { id: "tKQ58Outrkw", title: "Crohn's Disease — what patients should know", duration: "Watch", category: "IBS & Bowel" },
    { id: "WK1pecff6aA", title: "Peptic Ulcer & H. pylori — the cure pathway", duration: "Watch", category: "Acidity & Reflux" },
    { id: "0nR6SHUmxrQ", title: "Hepatitis C — now curable in 12 weeks", duration: "Watch", category: "Hepatitis" },
    { id: "Rz-_9SoPESc", title: "Gallstones & biliary disease — when to act", duration: "Watch", category: "Diet & Lifestyle" },
    { id: "h3C10HmqUpQ", title: "Abdominal pain — making sense of causes", duration: "Watch", category: "IBS & Bowel" },
    { id: "2AVuUJSduCA", title: "ERCP — therapeutic endoscopy explained", duration: "Watch", category: "Endoscopy" },
    { id: "5xlEYRu0nHY", title: "Probiotics — when do they actually help?", duration: "Watch", category: "Diet & Lifestyle" },
    { id: "F-abHz3YcNE", title: "Liver-friendly diet — what to eat", duration: "Watch", category: "Diet & Lifestyle" },
    { id: "XHjg9vg7vdg", title: "Polypectomy — preventing colon cancer", duration: "Watch", category: "Endoscopy" },
    { id: "_0sWXeKV0Xk", title: "Endoscopic Ultrasound (EUS) explained", duration: "Watch", category: "Endoscopy" },
  ],
  categories: [
    "Liver Health",
    "Acidity & Reflux",
    "Endoscopy",
    "Hepatitis",
    "IBS & Bowel",
    "Diet & Lifestyle",
    "Patient Stories",
  ],
};

export const REVIEWS = [
  {
    name: "Ankit S.",
    location: "Varanasi",
    text: "Dr. Dixit explained my fatty liver diagnosis clearly and gave a practical plan. My readings improved in 4 months.",
    rating: 5,
  },
  {
    name: "Priya M.",
    location: "Lanka",
    text: "Years of acidity. Endoscopy was painless, diagnosis was precise, and I finally got real relief. Highly recommended.",
    rating: 5,
  },
  {
    name: "Ravi K.",
    location: "Chetganj",
    text: "Was anxious about colonoscopy. The clinic team and Doctor made the entire experience easy. Polyp removed in the same sitting.",
    rating: 5,
  },
  {
    name: "Sneha T.",
    location: "BHU Area",
    text: "Excellent IBS management — Dr. Dixit listens, then plans. Lifestyle changes plus medicine worked for me.",
    rating: 5,
  },
  {
    name: "Anwar H.",
    location: "Varanasi",
    text: "Hepatitis B carrier. Got a clear long-term plan, regular monitoring, no panic. The clinic is genuinely premium.",
    rating: 5,
  },
  {
    name: "Meera D.",
    location: "Cantt",
    text: "My father's jaundice was sorted out with proper workup. Took us seriously when other clinics dismissed it.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "What conditions does Dr. Indresh Dixit treat?",
    a: "Dr. Dixit is a DM Gastroenterologist treating the complete spectrum of digestive and liver conditions — acidity, GERD, gastritis, ulcers, IBS, chronic diarrhoea, ulcerative colitis, Crohn's disease, fatty liver, hepatitis, cirrhosis, pancreatitis, gallstones and biliary disease.",
  },
  {
    q: "What is Dr. Dixit's qualification and experience?",
    a: "DM in Gastroenterology from Banaras Hindu University (BHU), with 10+ years of dedicated GI and Liver practice. Member of ISG, INASL and SGEI.",
  },
  {
    q: "Where are the clinic locations in Varanasi?",
    a: "Two locations — Avashyakata Gastro Clinic, Lanka (behind V2 Mall) and Avashyakata Gastro Clinic, Chetganj (near Saroja Petrol Pump). Different hours at each.",
  },
  {
    q: "How do I book an appointment?",
    a: "Tap 'Book Appointment' on this site to message us on WhatsApp at +91 93696 98080, or call us directly. We confirm a time slot within minutes during clinic hours.",
  },
  {
    q: "Do you perform endoscopy and colonoscopy in-clinic?",
    a: "Yes. We perform diagnostic and therapeutic Upper GI Endoscopy, Colonoscopy, Polypectomy, foreign body removal, and advanced procedures including ERCP and EUS at partner centers.",
  },
  {
    q: "Is endoscopy painful?",
    a: "No. The procedure is done under mild sedation or local anaesthesia and is typically over in 15 minutes. Most patients return to routine the same day.",
  },
  {
    q: "How is fatty liver treated?",
    a: "Fatty liver is treated with a structured plan — dietary modification, gradual weight loss, control of diabetes/lipids, and targeted medication where indicated. Regular FibroScan monitoring tracks reversal.",
  },
  {
    q: "I have acidity for years — is it serious?",
    a: "Chronic acidity (especially with night-time reflux, dysphagia, weight loss or anaemia) needs an endoscopic evaluation. It is often easily controlled, but some patients require treatment for H. pylori, hiatus hernia or Barrett's esophagus.",
  },
  {
    q: "What is the difference between IBS and IBD?",
    a: "IBS is a functional disorder (no structural damage). IBD (Ulcerative Colitis, Crohn's) is an inflammatory autoimmune disease with visible damage on colonoscopy. Treatment is very different — accurate diagnosis is essential.",
  },
  {
    q: "Can Hepatitis B be cured?",
    a: "Chronic Hepatitis B is well-controlled with modern antivirals. Treatment goal is sustained viral suppression and prevention of cirrhosis/liver cancer. Long-term monitoring is essential.",
  },
  {
    q: "What is FibroScan and why is it needed?",
    a: "FibroScan is a non-invasive scan that measures liver stiffness — quantifying fatty liver (CAP) and fibrosis (kPa). It avoids the need for liver biopsy in most patients and tracks progress.",
  },
  {
    q: "Do you treat children?",
    a: "The practice is focused on adolescents and adults (15+). For pediatric GI issues we refer to a pediatric gastroenterologist.",
  },
  {
    q: "Do you accept insurance / TPA?",
    a: "OPD consultations are cash/UPI. For inpatient endoscopy or hospital admissions, most leading insurers and TPAs are accepted via partner hospitals.",
  },
  {
    q: "What should I bring to my first appointment?",
    a: "Past prescriptions, recent blood reports, any prior endoscopy/colonoscopy/USG/CT reports, and a list of current medicines. A short note of your symptoms helps too.",
  },
  {
    q: "Is the clinic wheelchair accessible?",
    a: "Yes. Both Lanka and Chetganj clinics are ground-floor accessible with seating space for attendants.",
  },
];
